import React, { useEffect } from "react";
import {
    Grid,
    Card,
    CardActionArea,
    CardContent,
    Typography,
    Box,
} from "@mui/material";
import {
    Folder as ProjectsIcon,
    Assessment as ReportsIcon,
    CalendarMonth as ScheduleIcon,
    Description as DocumentsIcon,
    RequestQuote as QuotesIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { usePermissions } from "../hooks/usePermissions";
import kodexLogo from "../assets/kodex_logo.svg";

const subcontractorItems = [
    {
        title: "Schedule",
        desc: "View your weekly work schedule.",
        path: "/field/schedule",
        icon: ScheduleIcon,
        color: "primary",
    },
    {
        title: "Projects",
        desc: "View projects you are assigned to.",
        path: "/projects",
        icon: ProjectsIcon,
        color: "primary",
    },
    {
        title: "Quotes",
        desc: "View quotes linked to your company.",
        path: "/subcontractor/quotes",
        icon: QuotesIcon,
        color: "primary",
    },
    {
        title: "Reports",
        desc: "Access reports for your projects.",
        path: "/reports",
        icon: ReportsIcon,
        color: "primary",
    },
    {
        title: "My Documents",
        desc: "Personal documents on file for you, not project files.",
        path: "/my-documents",
        icon: DocumentsIcon,
        color: "primary",
    },
];

function SubcontractorDashboard() {
    const navigate = useNavigate();
    const { isSubcontractor } = usePermissions();

    useEffect(() => {
        if (!isSubcontractor) navigate("/", { replace: true });
    }, [isSubcontractor, navigate]);

    return (
        <Box>
            <Box sx={{ mb: 3, textAlign: "center" }}>
                <img
                    src={kodexLogo}
                    alt="Kodex Shielding Solutions"
                    style={{ height: 100, width: "auto", marginBottom: 4 }}
                />
                <Typography
                    variant="caption"
                    display="block"
                    color="text.secondary"
                    sx={{
                        fontFamily: "Montserrat, sans-serif",
                        letterSpacing: "0.08em",
                        textTransform: "uppercase",
                    }}
                >
                    Subcontractor Portal
                </Typography>
            </Box>

            <Grid container spacing={2} justifyContent="center">
                {subcontractorItems.map(({ title, desc, path, icon: Icon, color }) => (
                    <Grid item xs={6} sm={4} md={3} key={path}>
                        <Card
                            sx={{
                                height: "100%",
                                boxShadow: "none",
                                border: 1,
                                borderColor: "primary.main",
                            }}
                        >
                            <CardActionArea
                                onClick={() => navigate(path)}
                                sx={{ height: "100%", alignItems: "flex-start" }}
                            >
                                <CardContent>
                                    <Box sx={{ mb: 1 }}>
                                        <Icon color={color} fontSize="medium" />
                                    </Box>
                                    <Typography
                                        variant="subtitle2"
                                        sx={{
                                            fontFamily: "Montserrat, sans-serif",
                                            fontWeight: 700,
                                            lineHeight: 1.3,
                                            mb: 0.5,
                                        }}
                                    >
                                        {title}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                        {desc}
                                    </Typography>
                                </CardContent>
                            </CardActionArea>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}

export default SubcontractorDashboard;
